import { render, staticRenderFns } from "./ArtPerf.vue?vue&type=template&id=b0078e86&"
import script from "./ArtPerf.vue?vue&type=script&lang=ts&"
export * from "./ArtPerf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports